import { getRequest } from 'API/ApiClient'

export const getSlackAuthURL = async () => {
  return getRequest({ path: '/api/alerts/slack' })
}
